import { AssetsProps } from "~/pages/tickets/ticket/TicketPage/TicketAssetsSection/types";
import { Box, Button, Collapse, Grid } from "@mui/material";
import { SectionHeading } from "~/components/DetailsPage/components";
import { TicketAssetsTable } from "~/pages/tickets/ticket/TicketPage/TicketAssetsSection/TicketAssetsTable";
import { useState } from "react";
import { Flex } from "~/components/Flex";
import {
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";
import { pluralize } from "~/lib/pluralize";
import { EmptySection } from "~/components/vulnerabilities";

export const TicketMitigatedAssets = ({
  assets,
  orderBy,
  urlContextType,
  contextId,
  filteredTotalCount,
  fetchMore,
  pageInfo,
  handleSortClick,
  totalCount,
  scope,
}: AssetsProps) => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <Grid size={12}>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        gap={2}
        sx={{
          "& .section-header": {
            flex: "1 0 auto",
          },
        }}
      >
        <SectionHeading heading="Mitigated Assets" />
        {totalCount > 0 && (
          <Button
            variant="text"
            color="primary"
            endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            onClick={() => setOpen((isOpen) => !isOpen)}
          >
            SHOW {totalCount} {pluralize("ASSET", totalCount)}
          </Button>
        )}
      </Flex>
      {totalCount > 0 ? (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Box className="section-content">
            <TicketAssetsTable
              assets={assets}
              contextId={contextId}
              fetchMore={fetchMore}
              filteredTotalCount={filteredTotalCount}
              handleSortClick={handleSortClick}
              orderBy={orderBy}
              pageInfo={pageInfo}
              scope={scope}
              urlContextType={urlContextType}
              totalCount={totalCount}
            />
          </Box>
        </Collapse>
      ) : (
        <EmptySection
          id="mitigated-assets-empty"
          text="There are currently no mitigated assets."
        />
      )}
    </Grid>
  );
};
